import React from 'react'
import './StepProgress.css'

type StepProgressProps = {
  current?: number | undefined
  steps: number
  style?: React.CSSProperties
}

function StepProgress({ current = 0, steps, style }: StepProgressProps) {
  return (
    <div className='cocunat-StepProgress' style={style}>
      {Array.from({ length: steps }, (_, i) => {
        return (
          <div
            className={i + 1 <= current ? 'cocunat-StepProgress_active' : ''}
            key={`key-${i}`}
          ></div>
        )
      })}
    </div>
  )
}

export default StepProgress
